import Alert from "react-bootstrap/Alert";

export default function AlertMsg({message, variant = 'danger'}) {

    return <Alert key='danger' variant={variant}>
        {message ?
            message :
            'Ocorreu um erro inesperado, tente novamente mais tarde'
        }
    </Alert>
}